import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(private httpClient: HttpClient) { }

  get(url: string, options?: any): Observable<any> {
    return this.httpClient.get(url, options);
  }

  post(url: string, body: any, options?: any): Observable<any> {
    return this.httpClient.post(url, body, options);
  }

  put(url: string, body: any, options?: any): Observable<any> {
    return this.httpClient.put(url, body, options);
  }

  patch(url: string, body: any, options?: any): Observable<any> {
    return this.httpClient.patch(url, body, options);
  }

  delete(url: string, options?: any): Observable<any> {
    return this.httpClient.delete(url, options);
  }
}